module.exports = __webpack_public_path__ + "fonts/Inter-600-greek60.4a4b49c.woff2";